import React, { Component } from "react";
import image1 from "../../../../images/Prosthodonticsimg/image1.png";
import { NavLink } from "react-router-dom";

export class ProsthodonticsSidebar extends Component {
  render() {
    return (
      <div>
        <div className="widget widget-nav-menu">
          <ul className="widget-menu">
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/Prosthodontics"}>
                About
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/ProFaculties"}>
                Faculties and Staff
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/ProTeaching"}>
                Teaching - Learning
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/ProResearch"}>
                Research and Innovations
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/ProActivities"}>
                Activities
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="widget">
          <div className="section-title with-desc text-center clearfix">
            <div className="title-header">
              <h2 className="title">
                Head of the{" "}
                <span className="ttm-textcolor-blue">Department</span>
              </h2>
            </div>
          </div>

          <div className="ttm_single_image-wrapper mb-35 res-991-mb-20">
            <img
              className="d-block w-100"
              src={image1}
              alt="Dr Surendra Kumar G P"
            />
          </div>

          <h5 style={{ color: "black" }}>Dr. Surendra Kumar G.P.</h5>
          <p>Professor & HOD</p>

          <h6>Education & Qualification:</h6>
          <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15">
            <li>
              <i className="fas fa-star"></i>
              BDS: Bapuji Dental College & Hospital, Davanagere (1989)
            </li>
            <li>
              <i className="fas fa-star"></i>
              MDS: Bapuji Dental College & Hospital, Davanagere (1994)
            </li>
          </ul>

          <h6>Work Experience:</h6>
          <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15">
            <li>
              <i className="fas fa-star"></i> Assistant Professor (1994 – 1998)
            </li>
            <li>
              <i className="fas fa-star"></i> Associate Professor (2002 – 2007)
            </li>
            <li>
              <i className="fas fa-star"></i> Professor (2007 – Till Date)
            </li>
            <li>
              <i className="fas fa-star"></i> Total 32 Years of Teaching
              Experience
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default ProsthodonticsSidebar;
